export class ScholarshipOverviewFilters {
	public title: string | undefined;

	public isEmpty(): boolean {
		return this.title === undefined || this.title.trim().length === 0;
	}

	public reset(): void {
		this.title = undefined;
	}
}
